import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { mergeMap, Observable, retryWhen } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { AuthActions } from '../component/auth/state/action-types';

@Injectable()
export class HttpErrorsInterceptor implements HttpInterceptor {
    constructor(private store: Store<AppState>) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            retryWhen((error) => {
                return error.pipe(
                    mergeMap((error, index) => {
                        switch (error.status) {
                            case 401:
                                this.store.dispatch(AuthActions.logout());
                                break;
                            case 404:
                                break;
                            case 500:
                                break;
                            default:
                                break;
                        }

                        throw error;
                    })
                );
            })
        );
    }
}
